<template>
  <div>
    <b-form @submit.prevent="handleSaveBusiness" class="pb-3" v-if="!fetching">
      <b-row class="manager-business-setting">
        <b-col sm="12" lg="12" style="padding: 0" class="business-setting">
          <b-card class="mb-4 business-card">
            <b-card-body class="business-card-body p-0">
              <div class="container business-container">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <span style="font-weight: semi-bold; font-size: 20pt">{{ __('Business') }}</span>
                  </div>
                </div>
                <hr class="mt-1" />
                <div class="col-md-12 business-form">
                  <b-form-group>
                    <b-row class="mb-1">
                      <div class="col-md-2">
                        <label class="form-title d-inline-block w-100 pt-2">
                          {{ __('Business Name') }}
                          <span class="required">*</span>
                        </label>
                      </div>
                      <div class="col-md-10">
                        <b-form-input v-model="business.issuer_name" :placeholder="__('Enter business name...')">
                        </b-form-input>
                      </div>
                    </b-row>
                  </b-form-group>
                  <b-form-group>
                    <b-row class="mb-1">
                      <div class="col-md-2">
                        <label class="form-title d-inline-block w-100 pt-2">
                          {{ __('Brand Name') }}
                          <span class="required">*</span>
                        </label>
                      </div>
                      <div class="col-md-10">
                        <b-form-input v-model="business.brand_name" :placeholder="__('Enter brand name...')">
                        </b-form-input>
                      </div>
                    </b-row>
                  </b-form-group>
                  <b-row>
                    <b-col md="6" sm="12">
                      <b-form-group>
                        <b-row class="mb-1 float-left">
                          <div class="col-md-4">
                            <label class="form-title d-inline-block w-100 pt-2">
                              {{ __('Business Email') }}
                              <span class="required">*</span>
                            </label>
                          </div>
                          <div class="col-md-8 manager-business-email">
                            <b-form-input v-model="business.issuer_email" :placeholder="__('Enter business email...')">
                            </b-form-input>
                          </div>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                      <b-form-group>
                        <b-row class="mb-1 phone-number">
                          <div class="col-md-5">
                            <label class="form-title d-inline-block w-100 pt-2">
                              <span v-html="__('Business Phone Number')"></span>
                              <span class="required">*</span>
                            </label>
                          </div>
                          <div class="col-md-7 manager-business-phone">
                            <b-form-input
                              v-model="business.issuer_phone"
                              :placeholder="__('Enter business phone number...')"
                            >
                            </b-form-input>
                          </div>
                        </b-row>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" class="text-center mt-5 mb-3">
                      <b-button type="submit" variant="primary">
                        {{ __('Save') }}
                      </b-button>
                    </b-col>
                  </b-row>

                  <b-alert :variant="success ? 'success' : 'danger'" v-if="message" show>
                    {{ message }}
                  </b-alert>

                  <div v-for="(errs, field) in errors" :key="field">
                    <b-alert v-for="err in errs" :key="err" variant="danger" show>
                      {{ err }}
                    </b-alert>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  data() {
    return {
      fetching: false,
      success: false,
      errors: {},
      message: '',
      business: {
        issuer_name: '',
        brand_name: '',
        issuer_email: '',
        issuer_phone: '',
      },
    };
  },

  async mounted() {
    this.business = await this.fetchBusinessSettings();
  },

  methods: {
    async fetchBusinessSettings() {
      this.fetching = true;
      try {
        let {
          data: {
            data: {
              enabled,
              settings: { value },
            },
          },
        } = await axios.get('/api/business_settings');
        return { enabled, ...value };
      } catch (err) {
      } finally {
        this.fetching = false;
      }
    },

    async handleSaveBusiness() {
      this.success = false;
      this.message = '';
      this.errors = {};
      let postData = { ...this.business, _method: 'put' };
      try {
        let {
          data: { message, success },
        } = await axios.post('/api/business_settings', postData);
        this.success = success;
        this.message = message;
      } catch (error) {
        this.success = false;
        this.message = error.response.data.message;
        this.errors = error.response.data.errors;
      } finally {
      }
    },
  },
};
</script>

<style>
.layout-sidebar-large .main-content-wrap {
  background-image: url('@/assets/images/form/form-bg-orange.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}

.phone-number {
  float: right;
}

.manager-business-email {
  padding-left: 5%;
}

@media only screen and (max-width: 360px) {
  .business-card-body,
  .business-container {
    padding: 0;
  }

  .business-form {
    padding: 0;
  }

  .layout-sidebar-large .main-content-wrap {
    padding-right: 10px;
  }
}

@media only screen and (max-width: 768px) {
  .phone-number {
    float: none;
  }

  .business-form {
    padding: 0;
  }

  .manager-business-email {
    padding-left: 7%;
  }
}

@media only screen and (max-width: 600px) {
  .manager-business-setting {
    width: 113% !important;
  }
}
</style>
